module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAeCAYAAAARgF8NAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAChSURBVCiR7ZMxDoJAFETf340WlMRkjQ3BGq7jTeQSXoAzcB2tMTaGLaS0wHy+hbEwgd6Cad+bTDUC0IWQj+oqQQ4AhjUvP56yGFu5hbBfqz8DCb95itfCrdQdJyBAMqqr5L7ZPQTSCQGD3s1BAIHUzcFvFmER/k4w6OegQe/Amvm+NdKFkJv6CxPXG7yWbhvjdfBaGlbzmesNq8VrkcXYvgGkCjfohTfoEwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/h1-2.png
// module id = qa6u
// module chunks = 1